import { defineMessages } from 'react-intl';

export default defineMessages({
  adminTools: 'Admin Tools',
  boardsDesc: 'The world\'s largest online genealogy community with over 25 Million posts on more than 198,000 boards.',
  categories: '{name} Categories',
  messageBoards: 'Message Boards'
});
